import { z } from "zod";

export const catalogSchema = () => {
  return z.object({
    name: z.string().min(1),
  });
};

export type CatalogFormValues = z.infer<ReturnType<typeof catalogSchema>>;
